import React from 'react';
import "./Nav.scss";
import useGlobalStyles from '../../globalStyles';
import clsx from 'clsx';
import { Box } from '@material-ui/core';
import UserAvatar from '../User/UserAvatar';
import { ADVISOR_OBJECT_KEY, SESSION_STORAGE_ACCOUNT_KEY, getSessionStorageItem } from '../../sessionStorage';

export default function Nav({ expanded, isSignWithoutAuth }) {
  const globalClasses = useGlobalStyles();

  const accountObj = getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY);
  const advisorObj = getSessionStorageItem(ADVISOR_OBJECT_KEY);

  const logoURL = (accountObj && accountObj.account && accountObj.account.logoUrl) ? accountObj.account.logoUrl : `${process.env.PUBLIC_URL}/logos/covr-logo.svg`;
  const userName = advisorObj ? `${advisorObj.firstName} ${advisorObj.lastName}` : '';

  return (
    <div id="advisor-nav" className={clsx(globalClasses.flexDisplay, globalClasses.justifyContentBetween, globalClasses.alignItemsCenter, 'sticky-top', isSignWithoutAuth && 'ml-0', (expanded) ? "sidebar-open" : "sidebar-close")}>
      <img id="partner-logo" alt="partner-logo" src={logoURL} />
      {!isSignWithoutAuth && <div className={clsx(globalClasses.flexDisplay, globalClasses.alignItemsCenter)}>
        <Box ml={2} />
        <UserAvatar name={userName} />
      </div>}
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/Layout/Nav.js